import React from 'react'
import './nodeForm.css'
/** OWN COMPONENTS */
import GeneralInfo from './GeneralInfo/GeneralInfo'
import {LogSensorList} from "./log_list/log_sensor_list";

/** IMPORT REACT TOOLBOX COMPONENTS */
import IconButton from "react-toolbox/lib/button/IconButton"
/*** REDUX  ****/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {withRouter, Link, Redirect} from "react-router-dom";
/*** REDUX ACTINS ***/
import * as DeviceActions from '../../../../actions/devices'

import {GetDeviceLog} from "../../../../requests";

class nodeForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            id: props.match.params.id,
            device: props.match.params.id !== 'new' ? props.devices.find(device => device.id === props.match.params.id) : {},
            newSensor: props.match.params.id === 'new',
            log: []
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        let prevSensor = prevProps.devices.find(device => device.id === this.state.id);
        let newSensor = this.props.devices.find(device => device.id === this.state.id);

        if (prevSensor !== newSensor)
            this.setState({...this.state, device: newSensor});
    }

    componentDidMount() {
        if (!this.state.newStation)
            GetDeviceLog(sessionStorage.getItem('x-auth-token'), this.state.id,
                (resp, err) => {
                    if (err) console.log(err);
                    else
                        this.setState({...this.state, log: resp.log});
                });
    }

    handleSubmit(device) {
        if (this.state.newSensor) {
            this.props.devicesActions.createDevice(device, (resp, err) => {
                if (!err) {
                    this.setState({...this.state, redirect: true});
                } else {
                    console.log(resp);
                }
            });
        } else {
            this.props.devicesActions.updateDevice(device, (resp, err) => {
                if (!err) {
                    this.setState({...this.state, redirect: true});
                } else {
                    console.log(resp);
                }
            });
        }
    }

    handleRender() {
        return (
            <div className='col-xs-12'>
                {this.state.newSensor ?
                    <GeneralInfo title={'General Info'}
                                 isCreate={this.state.newSensor}
                                 device={this.state.device}
                                 handleSubmit={this.handleSubmit.bind(this)}
                    />
                    :
                    <div>
                        <div className='col-xs-3'>
                            <GeneralInfo title={'General Info'}
                                         isCreate={this.state.newSensor}
                                         device={this.state.device}
                                         handleSubmit={this.handleSubmit.bind(this)}
                            />
                        </div>
                        <div className='col-xs-9'>
                            <LogSensorList logs={this.state.log}/>
                        </div>
                    </div>
                }
            </div>
        );
    }


    render() {
        if (this.state.redirect)
            return <Redirect push to={"/admin/nodes"}/>;

        let title = this.state.newSensor ? ' Node Registration ' : ' Node Details ';

        return (
            <div className='col-xs-12'>
                <div className="createSensor">
                    <h3 className="formHeader"> {title}</h3>
                    <Link to={'/admin/nodes'}><IconButton primary
                                                          className="buttonClose"
                                                          icon="close"
                    /></Link>
                    {this.handleRender()}
                </div>
            </div>
        )
    }
}


const gasInfoStateToProps = (state) => {
    return {
        devices: state.devices.list,
    }
};


const registerDispatchToProps = (dispatch) => {
    return {
        devicesActions: bindActionCreators(DeviceActions, dispatch),
    }
};


export default withRouter(connect(gasInfoStateToProps, registerDispatchToProps)(nodeForm))




// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminNodes/NodeForm/nodeForm.js